import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ServicioService } from '../servicios/servicio.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Utils } from '../utils/utils';

@Component({
  selector: 'app-serviciosasignados',
  templateUrl: './serviciosasignados.component.html',
  styleUrls: ['./serviciosasignados.component.css']
})
export class ServiciosasignadosComponent implements OnInit {
  displayedColumns: string[] = [
    'NroServicio',
    'Prioridad',
    'Nombre',
    'tipoDireccion',
    'Telefono',
    'Direccion',
    'Municipio',
    'Departamento'
  ];
  dataSource: MatTableDataSource<any>;
  isData = false;

  @ViewChild(MatSort, {static: false}) sort: MatSort;
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;

  constructor(private sServicio: ServicioService, public ruta: Utils,) {
    this.sServicio.getInformeServiciosAsignados().subscribe(data => {
      console.log(JSON.stringify(data));
      this.isData = true;
      this.dataSource = new MatTableDataSource(data);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  ngOnInit() {
    this.ruta.setRuta();
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
}
